import Row from '@components/Row';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

import SubCategoryContext from './SubCategoryContext';

interface Props<T> {
    children?: ReactNode;
    value: T;
    setValue: (v: T) =>void;
    className?: string;
    isColorful?: boolean;
}

function Container<T>({
    children, value, setValue, className, isColorful,
}:Props<T>) {
    return (
        <SubCategoryContext value={{ value, setValue, isColorful }}>
            <Base fullWidth
                spacing={10}
                className={className}>
                {children}
            </Base>
        </SubCategoryContext>
    );
}

const Base = styled(Row)`
    overflow-x: auto;
    padding: 16px 20px;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export default Container;
